import { Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { FacilityType } from '@schooly/api';
import { AddYourSchoolSvg, PlusIcon } from '@schooly/style';
import { FC } from 'react';
import { useIntl } from 'react-intl';

type SchoolGeneralFacilitiesEmptyCardProps = {
  handleAddFacility: (type: FacilityType) => void;
};

export const SchoolGeneralFacilitiesEmptyCard: FC<SchoolGeneralFacilitiesEmptyCardProps> = ({
  handleAddFacility,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Card sx={{ backgroundColor: 'background.default', border: 'none' }}>
      <CardContent>
        <Stack direction="row" justifyContent="space-between">
          <Stack gap={6}>
            <Stack gap={1}>
              <Typography
                variant="h2"
                sx={(theme) => ({
                  [theme.breakpoints.only('xl')]: {
                    whiteSpace: 'pre-wrap',
                  },
                })}
              >
                {formatMessage({ id: 'school-tabs-Facilities-Empty-Title' })}
              </Typography>
              <Typography
                variant="h3"
                color="text.primary"
                sx={(theme) => ({
                  [theme.breakpoints.up('lg')]: {
                    whiteSpace: 'pre-wrap',
                  },
                })}
              >
                {formatMessage({ id: 'school-tabs-Facilities-Empty-Description' })}
              </Typography>
            </Stack>

            <Stack direction="row" gap={1} flexWrap="wrap">
              <Button
                variant="outlined"
                startIcon={<PlusIcon />}
                sx={{ backgroundColor: 'background.paper' }}
                onClick={() => handleAddFacility(FacilityType.Campus)}
              >
                {formatMessage({ id: 'school-tabs-Facilities-AddCampus' })}
              </Button>
              <Button
                variant="outlined"
                startIcon={<PlusIcon />}
                sx={{ backgroundColor: 'background.paper' }}
                onClick={() => handleAddFacility(FacilityType.Building)}
              >
                {formatMessage({ id: 'school-tabs-Facilities-AddBuilding' })}
              </Button>
              <Button
                variant="outlined"
                startIcon={<PlusIcon />}
                sx={{ backgroundColor: 'background.paper' }}
                onClick={() => handleAddFacility(FacilityType.Room)}
              >
                {formatMessage({ id: 'school-tabs-Facilities-AddRoom' })}
              </Button>
            </Stack>
          </Stack>
          <img
            width={185}
            src={AddYourSchoolSvg}
            alt={formatMessage({ id: 'school-tabs-Facilities-Empty-Title' })}
          />
        </Stack>
      </CardContent>
    </Card>
  );
};
